import React from 'react';
import styles from './searchSuggestion.less';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';
import CategoryTiles from './categoryTiles/categoryTiles';
import CharityList from './charityList';

export default class extends React.Component {
  renderHeader = () => {
    return (
      <div>
        {!this.props.noSearchResult ? (
          <BodyText style={{ marginTop: '48px' }} size='md' regular>
            {this.props.i18n('label.charityRecommendTitle2')}
          </BodyText>
        ) : null}
      </div>
    );
  };
  renderTiles = () => {
    return (
      <div className={styles['searchResult-Tile']}>
        <CategoryTiles
          id={'charityCategories'}
          categories={this.props.categories}
          fundraiserCategories={this.props.fundraiserCategories}
          coBrand={this.props.coBrand}
          fptiInfo={this.props.fptiInfo}
          i18n={this.props.i18n}
          type={this.props.searchType || 'all'}
        />
      </div>
    );
  };

  renderList = () => {
    return (
      <CharityList
        {...this.props}
        charities={this.props.suggestedCharties}
        fptiInfo={this.props.fptiInfo}
        i18n={this.props.i18n}
      />
    );
  };

  render() {
    return (
      <div className={styles['searchResultTile-container']}>
        {this.renderHeader()}
        {this.props.showCategory ? this.renderTiles() : this.renderList()}
      </div>
    );
  }
}
